import { Game } from '@repo/types'
import { ToggleSwitch } from '@repo/ui'
import { observer } from 'mobx-react-lite'
import React from 'react'

import { useGameContext } from '@/pages/game/context/game-context'
import { updateGameSetting } from '@/store/game/updateGameDocument'

import { SettingsRow } from '../SettingsRow'

const SETTING_NAME = 'Fullscreen QR Code'
const SETTING_ID = 'jumbotron.enableQRCodeFullscreen' as const

export const EnableJumbotronQRCodeFullscreen = observer(
  function EnableJumbotronQRCodeFullscreen(): React.ReactElement {
    const { gameData, gameId, tracker } = useGameContext()

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      const { checked } = event.target

      const update: Pick<Game, typeof SETTING_ID> = {
        [SETTING_ID]: checked
      }

      void updateGameSetting(gameId, update)
      tracker.changeToggle(`Jumbotron ${SETTING_NAME}`, checked)
    }

    return (
      <SettingsRow
        description='Show the QR code using the full size of the screen.'
        heading={SETTING_NAME}
      >
        <ToggleSwitch
          id={SETTING_ID}
          isChecked={gameData.jumbotron.enableQRCodeFullscreen}
          isDisabled={!gameData.jumbotron.enableQRCode}
          onChange={handleChange}
        />
      </SettingsRow>
    )
  }
)
